import { ALL_SUPPORTED_CHAINS } from '../constants/chains.js';
import { SDKReferenceError } from '../errors/primitives.js';
import { createPublicClient, http, } from 'viem';
import { mainnet } from 'viem/chains';
export class ContextHost {
    constructor({ env, chainId } = {
        env: 'production',
        chainId: mainnet.id,
    }, clients) {
        Object.defineProperty(this, "env", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "chainId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "publicClient", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "walletClient", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "createPublicClient", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (chainId) => {
                return createPublicClient({
                    chain: ALL_SUPPORTED_CHAINS.find((c) => c.id === chainId),
                    transport: http(),
                });
            }
        });
        Object.defineProperty(this, "host", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (service) => {
                const host = this.isProduction
                    ? service.production
                    : this.isStaging
                        ? service.staging
                        : service.development;
                if (!host) {
                    throw new SDKReferenceError('host', `request host not defined for env: ${this.env}`);
                }
                return host;
            }
        });
        this.env = env;
        this.chainId = chainId;
        this.publicClient =
            clients?.publicClient || this.createPublicClient(this.chainId);
        this.walletClient = clients?.walletClient;
    }
    useWalletClient() {
        if (this.walletClient)
            return this.walletClient;
        throw new SDKReferenceError('walletClient');
    }
    updateContext({ env, chainId, }) {
        if (env) {
            this.env = env;
        }
        if (chainId) {
            this.chainId = chainId;
        }
    }
    get isProduction() {
        return this.env === 'production';
    }
    get isStaging() {
        return this.env === 'staging';
    }
}
//# sourceMappingURL=contextHost.js.map